import { useAppDispatch, useAppSelector } from "app/hooks";
import FeatureToggle from "enums/FeatureToggle";
import { useEffect, useMemo, useRef, useState } from "react";

import {
    GuxButton,
    GuxIcon,
    GuxList,
    GuxListItem,
    GuxPopover,
} from "genesys-spark-components-react";
import { isNonProdRegion } from "util/envUtils";
import { selectFeatureToggle, toggle } from "./featureToggleSlice";

function FeatureToggleToggler({ toggle }: { toggle: FeatureToggle }) {
    const toggleEnabled = useAppSelector((state) =>
        selectFeatureToggle(state, toggle)
    );
    return (
        <div className="FeatureToggleToggler">
            <GuxIcon
                iconName={toggleEnabled ? "checkbox-active" : "checkbox"}
                decorative={true}
                style={{ marginRight: "5px", verticalAlign: "middle" }}
            ></GuxIcon>
            {toggle}
        </div>
    );
}

const style: React.CSSProperties = {
    position: "absolute",
    bottom: "0",
    width: "48px",
    zIndex: 4,
};

const scrollable: React.CSSProperties = {
    maxHeight: "300px",
    overflowY: "auto",
};

export default function FeatureToggleSelector() {
    const canShowToggleSelector = isNonProdRegion();
    const showToggleSelector = useMemo(
        () =>
            canShowToggleSelector &&
            localStorage.getItem("featureToggleOverrides") !== null,
        [canShowToggleSelector]
    );
    const popover = useRef<HTMLGuxPopoverElement>(null);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (popover?.current) {
            popover.current.hidden = !isOpen;
        }
    }, [popover, isOpen]);

    const dispatch = useAppDispatch();
    const featureToggles = Object.values(FeatureToggle).map((featureToggle) => (
        <GuxListItem
            key={featureToggle}
            onClick={() => dispatch(toggle(featureToggle))}
        >
            <FeatureToggleToggler toggle={featureToggle}></FeatureToggleToggler>
        </GuxListItem>
    ));

    return showToggleSelector ? (
        <div className="FeatureToggleSelector" style={style}>
            <GuxPopover
                for="FeatureToggleSelectorButton"
                isOpen={isOpen}
                ref={popover}
                onGuxdismiss={() => {
                    setIsOpen(false);
                }}
            >
                <div style={scrollable}>
                    <GuxList>{featureToggles}</GuxList>
                </div>
            </GuxPopover>
            <GuxButton
                id="FeatureToggleSelectorButton"
                onClick={() => {
                    setIsOpen(!isOpen);
                }}
            >
                <GuxIcon iconName="settings" decorative={true}></GuxIcon>
            </GuxButton>
        </div>
    ) : (
        <></>
    );
}
